export function opacityForAccess(
  canAccess: boolean,
  isDark: boolean
): import("csstype").Property.Opacity | undefined {
  return canAccess ? 1 : isDark ? 0.1 : 0.3;
}
